// src/components/SaleCancelForm/SaleFoundCard.tsx
import React, { useMemo } from 'react';
import { SelectedSaleInfo } from '../../../types/sale/invalidation/SelectedSaleInfo';
import { Calendar, User } from 'lucide-react';
import SaleFoundCardHeader from './card/SaleFoundCardHeader';
import SaleFoundInfoRow from './card/SaleFoundInfoRow';
import SaleFoundCodeBlock from './card/SaleFoundCodeBlock';


type Props = {
  data: SelectedSaleInfo;
  className?: string;
  currency?: string; // ej: "USD"
};

const SaleFoundCard: React.FC<Props> = ({ data, className, currency = 'USD' }) => {
  if (!data) return null;

  const amountLabel = useMemo(() => {
    if (data.total == null) return '—';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
      }).format(Number(data.total));
    } catch {
      return Number(data.total).toFixed(2);
    }
  }, [data.total, currency]);

  return (
    <div
      className={[
        'rounded-2xl border border-stroke dark:border-strokedark',
        'bg-white dark:bg-boxdark',
        'p-4 sm:p-5 shadow-sm hover:shadow transition-shadow',
        className ?? '',
      ].join(' ')}
    >
      <SaleFoundCardHeader
        documentTypeName={data.documentTypeName}
        controlNumber={data.controlNumber}
        amountLabel={amountLabel}
      />

      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-3 text-sm">
        <SaleFoundInfoRow
          icon={<Calendar className="h-4 w-4" />}
          label="Fecha"
          value={data.saleDate ?? '—'}
        />
        <SaleFoundInfoRow
          icon={<User className="h-4 w-4" />}
          label="Cliente"
          value={data.customerName ?? '—'}
        />
        <div className="hidden lg:block" />
        <SaleFoundCodeBlock code={data.generationCode} />
      </div>
    </div>
  );
};

export default SaleFoundCard;
